export default {
	methods: {
		populatePlaceholders(content) {
			let newContent = content;
			if (newContent !== null) {
				// Company Name
				const companyNamePlaceholder = /{{CompanyName}}/g;
				const companyName = this.loggedInTenant.companyName !== null ? this.loggedInTenant.companyName : this.loggedInTenant.name;
				newContent = newContent.replace(companyNamePlaceholder, companyName);
			}

			return newContent;
		}
	}
};
